import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutGrid, CreditCard, Settings, Shield, LogOut } from "lucide-react";
import { Logo } from "./brand/Logo";
import CreditsBadge from "./CreditsBadge";
import { useAuth } from "../context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const NAV = [
  ["/home", "Projects", LayoutGrid],
  ["/billing", "Billing", CreditCard],
  ["/settings", "Settings", Settings],
];

export const AppHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-30 h-16 border-b border-slate-200/80 bg-white/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto h-full px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-4">
        <div className="flex items-center gap-8">
          <Logo to="/home" />
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map(([to, label, Icon]) => (
              <NavLink
                key={to}
                to={to}
                data-testid={`app-nav-${label.toLowerCase()}`}
                className={({ isActive }) => `flex items-center gap-2 h-9 px-3 rounded-lg text-sm transition-colors ${isActive ? "bg-slate-100 text-slate-900" : "text-slate-500 hover:text-slate-900 hover:bg-slate-100"}`}
              >
                <Icon size={15} /> {label}
              </NavLink>
            ))}
            {user?.is_admin && (
              <NavLink to="/admin" data-testid="app-nav-admin" className="flex items-center gap-2 h-9 px-3 rounded-lg text-sm text-amber-600 hover:text-amber-700 hover:bg-slate-100 transition-colors">
                <Shield size={15} /> Admin
              </NavLink>
            )}
          </nav>
        </div>
        <div className="flex items-center gap-3">
          <CreditsBadge />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button data-testid="user-menu-trigger" className="w-9 h-9 rounded-full bg-gradient-to-br from-sky-400 to-indigo-400 text-white font-display font-bold text-sm hover:opacity-90 transition-opacity">
                {(user?.name || "?").charAt(0).toUpperCase()}
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56 bg-white border-slate-200">
              <div className="px-2 py-2">
                <div className="text-sm text-slate-900 font-medium truncate">{user?.name}</div>
                <div className="text-xs text-slate-500 truncate">{user?.email}</div>
              </div>
              <DropdownMenuSeparator className="bg-slate-100" />
              {NAV.map(([to, label, Icon]) => (
                <DropdownMenuItem key={to} onSelect={() => navigate(to)} className="md:hidden gap-2 cursor-pointer">
                  <Icon size={14} /> {label}
                </DropdownMenuItem>
              ))}
              {user?.is_admin && (
                <DropdownMenuItem onSelect={() => navigate("/admin")} className="md:hidden gap-2 cursor-pointer"><Shield size={14} /> Admin</DropdownMenuItem>
              )}
              <DropdownMenuItem onSelect={() => { logout(); navigate("/"); }} data-testid="logout-btn" className="gap-2 cursor-pointer text-rose-600 focus:text-rose-600">
                <LogOut size={14} /> Log out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
